
const env = {
    env: process.env.REACT_APP_ENV,
    app: {
        port: 3000
    },
    urls: {
      gql_url: process.env.REACT_APP_GQL_URL,
      queue_url: process.env.REACT_APP_QUEUE_URL,
      domain: process.env.REACT_APP_DOMAIN
    }
};

module.exports = env;
